<script setup lang="ts">
  import { computed } from 'vue';
  import {
    loaderWrapperClass,
    loaderWrapperMinHeightClass,
  } from './Loader.css';
  import Loader, { type LoaderProps } from './Loader.vue';

  const props = defineProps<LoaderProps & { minWrapper?: boolean }>();

  const loaderWrapperClasses = computed(() => ({
    [loaderWrapperClass]: true,
    [loaderWrapperMinHeightClass]: props.minWrapper,
  }));
</script>

<template>
  <div :class="loaderWrapperClasses"><Loader v-bind="props" /></div>
</template>
